export const STICKY_HEADERS_HEIGHT = 103;
